// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import APIS from "./api/index.js"


import {get,post,postparmars} from "./utils/http"
//引入 elementui 完整引入
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$api=APIS

//全局注册get.post方法
Vue.prototype.$http={
  get,
  post,
  postparmars,
}
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js